import { render, staticRenderFns } from "./WikiHome.vue?vue&type=template&id=ecb10b80&scoped=true"
import script from "./WikiHome.vue?vue&type=script&lang=js"
export * from "./WikiHome.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./WikiHome.scss?vue&type=style&index=1&id=ecb10b80&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb10b80",
  null
  
)

export default component.exports